import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import Estimation from "./components/Estimation";
import Gallery from "./components/Gallery";
import Actualites from "./components/Actualites";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import TrustBanner from "./components/TrustBanner";
import Quartiers from "./components/Quartiers";
import FAQ from "./components/FAQ";
import SellBanner from "./components/SellBanner";
import CallbackButton from "./components/CallbackButton";

const Home = () => {
  return (
    <div className="App bg-background">
      <Header />
      <main>
        <Hero />
        <TrustBanner />
        <Services />
        <About />
        <Quartiers />
        <Estimation />
        <Gallery />
        <Actualites />
        <FAQ />
        <Contact />
        <SellBanner />
      </main>
      <Footer />
      <CallbackButton />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
